module.exports = __webpack_public_path__ + "static/img/stat-check.02fb8279.png";